import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const apiKeyScopeEnum = z.enum([
    "sms:send",
    "sms:read",
    "devices:read",
    "devices:manage",
    "webhooks:manage",
    "contacts:manage",
]);
export const apiKeySchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    name: z.string().min(1).max(80),
    keyHash: z.string(),
    prefix: z.string().length(8),
    scopes: z.array(apiKeyScopeEnum).min(1),
    lastUsedAt: isoDateSchema.nullable(),
    expiresAt: isoDateSchema.nullable(),
    revokedAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
export const apiKeyPublicSchema = apiKeySchema.omit({ keyHash: true, userId: true });
export const createApiKeySchema = z.object({
    name: z.string().min(1).max(80),
    scopes: z.array(apiKeyScopeEnum).min(1),
    expiresAt: isoDateSchema.nullable().optional(),
});
/** Returned exactly once, at creation time, then never again. */
export const createApiKeyResponseSchema = z.object({
    apiKey: apiKeyPublicSchema,
    secret: z.string(), // full "sb_live_xxx" — shown once
});
//# sourceMappingURL=api-key.js.map